<template>
  <div class="container-fluid">
    <page-header
      :page="header.page"
      :actions="header.actions"
      left-side-class="col-xl-8"
      right-side-class="
        col-xl-4 align-items-end d-flex pb-2 justify-content-end
      "
    ></page-header>

    <filter-manager
      v-model="filter.model"
      :filters="filtersHeader"
      class="filter-manager_extended"
      search-container-class="search-btn"
      @center="(val) => getMunicipalities(val?.id)"
      @municipality="(val) => getSchools(val?.id)"
      @search="() => onSearchHandler()"
    />
    <custom-separator
      text="Resultado de las Solicitudes"
      class="my-4 custom-separator-line"
    />

    <div v-if="hasResults" class="search-result">
      <result-row
        v-for="(item, index) in results"
        :key="index"
        :item="item"
        :actions-to-show="resultRowActions"
        @open="handlerOpen"
        @close="handlerClose"
        @refresh="() => onSearchHandler(pagination.currentPage)"
      />
      <pagination
        v-if="pagination.totalItemCount > pagination.pageSize"
        :data="pagination"
        :page-size="pagination.pageSize"
        @pagination-go-page="onSearchHandler"
      />
    </div>

    <custom-result-not-found
      v-else
      class="mt-4 row pt-3"
      text="No se ha encontrado resultado de las solicitudes de materiales."
    />
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import ResultRow from '@/views/pei/materials-and-equipments-requests/components/ResultRow.vue';
import Pagination from 'pagination';
import materialsAndEquipmentsService from '@/services/api/materialsAndEquipments.api';
import inventoryOrderMaterialsAndEquipments from '@/services/api/inventoryOrderMaterialsAndEquipments.api';
const DEFAULT_PAGE_SIZE = 10;
import FilterManager from 'FilterManager';
import storeMixin from '@/mixin/storeGenerator';
import academicService from '@/services/api/academicUtils.api.js';
import * as bookService from '@/modules/books-requests/api';
import locationService from '@/services/api/location.api';
import EduEspCode from '@/utils/constants/eduEspCode';
import ACTIONS from '@/utils/constants/inventoryOrderBooksRowAction';

export default {
  name: 'RequestsBooks',
  mixins: [storeMixin],
  components: {
    PageHeader,
    CustomSeparator,
    CustomResultNotFound,
    FilterManager,
    Pagination,
    ResultRow,
  },
  data() {
    return {
      results: [],
      filter: {
        model: {
          catalog: null,
          saloon: null,
          status: null,
          category: null,
          center: null,
          municipality: null,
          school: null,
          requestDate: null,
          code: null,
        },
        options: {
          catalogs: [],
          saloons: [],
          categories: [],
          statuses: [],
          centers: [],
          municipalities: [],
          schools: [],
        },
      },
      pagination: {
        count: 0,
        currentPage: 1,
        pageCount: 1,
        totalItemCount: 0,
        pageSize: DEFAULT_PAGE_SIZE,
      },
    };
  },
  async mounted() {
    await Promise.all([
      this.getCatalogs(),
      this.getSubjects(),
      this.getStatuses(),
      this.getCenters(),
      this.getCategories(),
      this.getSaloons(),
    ]);
  },
  computed: {
    header() {
      return {
        page: {
          icon: 'fas fa-book-open',
          title: 'Manejo de Solicitudes de Materiales/Equipos',
          routes: [
            'Inicio',
            'Materiales',
            'Manejo de Solicitudes de Materiales/Equipos',
          ],
        },
        actions: [
          {
            text: 'Regresar',
            icon: 'fas fa-arrow-circle-left',
            variant: 'outline-success',
            visible: true,
            click: () => this.$router.go(-1),
          },
        ],
      };
    },
    resultRowActions() {
      return [
        ACTIONS.ViewInventory,
        ACTIONS.Info,
        ACTIONS.ViewAssignedBook,
        ACTIONS.Reject,
        ACTIONS.History,
        ACTIONS.DeliverToSchool,
        ACTIONS.ApprovePurchase,
        ACTIONS.ReceivedByMaster,
        ACTIONS.ConfirmPurchase,
        ACTIONS.PurchaseInfo,
        ACTIONS.DeliverToCsee,
      ];
    },
    hasResults() {
      return Boolean(this.results.length);
    },
    academicYearId() {
      return this.currentAcademicYear().id;
    },
    filtersHeader() {
      return [
        {
          name: 'catalog',
          component: 'CustomDropDown',
          options: this.filter.options.catalogs,
          value: this.filter.model.catalog,
          placeholder: 'Título de Material/Equipo',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-sm-6 col-md ml-0 mr-0',
          clearable: true,
        },
        {
          name: 'category',
          component: 'CustomDropDown',
          options: this.filter.options.categories,
          value: this.filter.model.category,
          placeholder: 'Categoría',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-sm-6 col-md ml-0 mr-0',
          clearable: true,
        },
        {
          name: 'status',
          component: 'CustomDropDown',
          options: this.filter.options.statuses,
          value: this.filter.model.status,
          placeholder: 'Estatus',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-sm-6 col-md ml-0 mr-0',
          clearable: true,
        },
        {
          name: 'code',
          component: 'CustomInput',
          value: this.filter.model.code,
          placeholder: 'Escriba el Número de Solicitud',
          icon: 'fa fa-search orange-icon',
          leftIcon: true,
          class: 'col-12 col-sm-6 col-md ml-0 mr-0',
          type: 'text',
          clearable: true,
        },
        {
          name: 'saloon',
          label: 'Tipo de Salón:',
          component: 'CustomDropDown',
          value: this.filter.model.saloon,
          options: this.filter.options.saloons,
          placeholder: 'Seleccione',
          class: 'col-12 col-md-3',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
        },
        {
          name: 'center',
          label: 'Centro:',
          component: 'CustomDropDown',
          value: this.filter.model.center,
          options: this.filter.options.centers,
          placeholder: 'Seleccione',
          class: 'col-12 col-md-3',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
        },
        {
          name: 'municipality',
          label: 'Municipio:',
          component: 'CustomDropDown',
          value: this.filter.model.municipality,
          options: this.filter.options.municipalities,
          placeholder: 'Seleccione',
          class: 'col-12 col-md-2',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
        },
        {
          name: 'school',
          label: 'Escuela:',
          component: 'CustomDropDown',
          value: this.filter.model.school,
          options: this.filter.options.schools,
          placeholder: 'Seleccione',
          class: 'col-12 col-md-2',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
        },
        {
          name: 'requestDate',
          component: 'CustomDatePicker',
          placeholder: 'Seleccione Fecha de Solicitud',
          label: 'Fecha de Solicitud:',
          class: 'col-12 col-md-2 w-100',
          type: 'date',
          isAdvanced: true,
        },
      ];
    },
  },
  methods: {
    async onSearchHandler(currentPage = 1) {
      const {
        catalog,
        category,
        saloon,
        status,
        center,
        municipality,
        school,
        requestDate,
        code,
      } = this.filter.model;

      const { pageSize } = this.pagination;

      const { data } = await inventoryOrderMaterialsAndEquipments.searchRequest(
        {
          catalogId: catalog?.id,
          statusId: status?.id,
          categoryId: category?.id,
          saloonTypeId: saloon?.id,
          centerId: center?.id,
          municipalityId: municipality?.id,
          schoolId: school?.id,
          requestNumberOrItemCode: code,
          requestDate,
          currentPage,
          pageSize,
        }
      );

      this.results = data.data.map((x) => ({
        ...x,
        isOpen: false,
      }));

      this.pagination = {
        pageSize: DEFAULT_PAGE_SIZE,
        totalItemCount: data.totalItemCount,
        pageCount: data.pageCount,
        currentPage: data.currentPage,
        count: data.count,
      };
    },
    async getCategories() {
      const { data } = await materialsAndEquipmentsService.getCategories();
      this.filter.options.categories = data;
    },
    async getSaloons() {
      const { data } = await materialsAndEquipmentsService.getSaloon();
      this.filter.options.saloons = data;
    },
    async getCatalogs() {
      const { data } = await materialsAndEquipmentsService.getKeyValue();
      this.filter.options.catalogs = data;
    },
    async getSubjects() {
      const { data } = await academicService.getEduEsp({
        codetype: EduEspCode.CatlibSubject,
      });
      this.filter.options.subjects = data;
    },
    async getStatuses() {
      const { data } = await bookService.getStatusList();
      this.filter.options.statuses = data;
    },
    async getCenters() {
      const { data } = await locationService.getCenters({
        academicYearId: this.academicYearId,
      });
      this.filter.options.centers = data;

      if (data.length === 1) {
        this.filter.model.center = data[0];
        this.getMunicipalities(data[0].id);
      }
    },
    async getMunicipalities(centerId) {
      this.filter.model.municipality = null;
      this.filter.model.school = null;
      this.filter.options.municipalities = [];
      this.filter.options.schools = [];

      if (!centerId) return;

      const { data } = await locationService.getMunicipalities({
        academicYearId: this.academicYearId,
        centerId,
      });
      this.filter.options.municipalities = data;

      if (data.length === 1) {
        this.filter.model.municipality = data[0];
        this.getSchools(data[0].id);
      }
    },
    async getSchools(municipalityId) {
      this.filter.model.school = null;
      this.filter.options.schools = [];

      if (!municipalityId) return;

      const academicYearId = this.currentAcademicYear().id;
      const { data } = await locationService.getSchools({
        academicYearId,
        centerId: this.filter.model.center.id,
        municipalityId,
      });
      this.filter.options.schools = data;
      if (data.length === 1) this.filter.model.school = data[0];
    },
    async handlerOpen(item) {
      this.results
        .filter((x) => x.id !== item.id && x.isOpen)
        .forEach((x) => (x.isOpen = false));

      item.isOpen = true;
    },
    handlerClose(item) {
      item.isOpen = false;
    },
  },
  destroyed() {
    this.persistData();
  },
  beforeRouteEnter(_, from, next) {
    const routes = [
      'inventoryRequestsMaterialsAndEquipments',
      'InventoryMaterialDetails',
    ];
    next(async (vm) => {
      if (routes.includes(from.name)) {
        vm.recoveryData();
        await vm.onSearchHandler();
      } else {
        vm.shouldRecovery = false;
      }
    });
  },
};
</script>

<style scoped>
::v-deep .custom-datetime-picker-container.width-container {
  width: 100% !important;
}
</style>
